import request from '@/utils/request'

const residentsApi = {
  // get residents info
  residents: '/api/v1/rest/residents',
  findByKeyword: '/api/v1/rest/residents/search/findByKeyword',
  findByHouses_Id: '/api/v1/rest/residents/search/findByHouses_Id',
  findByAllHouses_Id: '/api/v1/rest/residents/search/findAllByHouses_Id',
  add: '/api/v1/resident/register',
  query: '/api/v1/resident/query',
  deleteResidentHouse: '/api/v1/resident/deleteResidentHouse',
  updateResident: '/api/v1/resident/updateHouse',
  addHouseResident: '/api/v1/resident/addHouse'
}

export function residents(param) {
  return request({
    url: residentsApi.residents + `?page=${param.page}&size=${param.size}&sort=${param.sort}`,
    method: 'get'
  })
}

export function addResidents(param) {
  return request({
    url: residentsApi.add,
    method: 'post',
    data: param
  })
}

export function editResidents(param) {
  return request({
    url: residentsApi.residents + `/${param.id}`,
    method: 'patch',
    data: param
  })
}

export function delResidents(param) {
  return request({
    url: residentsApi.residents + `/${param.id}`,
    method: 'delete'
  })
}

export function getResidentHouses(id) {
  return request({
    url: residentsApi.residents + `/${id}/houses`,
    method: 'get'
  })
}

export function delResidentHouse(param) {
  let url = residentsApi.deleteResidentHouse
  if (param) {
    url += '?' + Object.keys(param).map(item => `${item}=${param[item]}`).join('&')
  }
  return request({
    url,
    method: 'post'
  })
}

export function postResidentHouse(id, data) {
  return request({
    url: residentsApi.residents + `/${id}/houses`,
    method: 'post',
    headers: {
      'Content-Type': 'text/uri-list'
    },
    data
  })
}

export function updateResidentHouse(param) {
  let url = residentsApi.updateResident
  if (param) {
    url += '?' + Object.keys(param).map(item => `${item}=${param[item]}`).join('&')
  }
  return request({
    url,
    method: 'get'
  })
}

export function addResidentHouse(param) {
  let url = residentsApi.addHouseResident
  if (param) {
    url += '?' + Object.keys(param).map(item => `${item}=${param[item]}`).join('&')
  }
  return request({
    url,
    method: 'get'
  })
}

export function findResidents(param) {
  let url = residentsApi.findByKeyword
  if (param) {
    url += '?' + Object.keys(param).map(item => `${item}=${param[item]}`).join('&')
  }
  return request({
    url,
    method: 'get'
  })
}

export function residentQuery(param) {
  let url = residentsApi.query
  if (param) {
    url += '?' + Object.keys(param).map(item => `${item}=${param[item]}`).join('&')
  }
  return request({
    url,
    method: 'get'
  })
}

export function findByIdResidents(param) {
  return request({
    url: residentsApi.Residents + `/${param.id}`,
    method: 'get'
  })
}

export function inResidents(param) {
  return request({
    url: residentsApi.residents + `/${param.id}/${param.name}`,
    method: 'get'
  })
}

export function findByHousesIdResident(param) {
  return request({
    url: residentsApi.findByHouses_Id + `?houseId=${param.id}&page=${param.page}&size=${param.size}&sort=${param.sort}`,
    method: 'get',
    headers: {
      'Content-Type': 'application/hal+json'
    }
  })
}

export function findByHousesIdAllResident(id) {
  return request({
    url: residentsApi.findByAllHouses_Id + `?houseId=${id}`,
    method: 'get'
  })
}
